/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  AccordionDetails, Typography, Grid, makeStyles, Checkbox, FormControlLabel, Box,
} from '@material-ui/core';
import ContentCheckbox from './ContentCheckbox';

const useStyles = makeStyles({
  skill: {
    marginTop: '10px',
  },
});

const ContentDetails = ({
  content,
  group,
  groupId,
  skillTitleId,
  contentIds,
  setContentIds,
}) => {
  const [allChecked, setAllChecked] = useState(false);
  const classes = useStyles();

  const handleAllChecked = () => {
    const newAllChecked = !allChecked;
    setAllChecked(newAllChecked);
    const contentIdsArr = [...contentIds];
    if (newAllChecked) {
      content.language.forEach((skillObj) => {
        if (!contentIdsArr.includes(skillObj.skillId)) {
          contentIdsArr.push(skillObj.skillId);
        }
      });
      content.functional.forEach((skillObj) => {
        if (!contentIdsArr.includes(skillObj.skillId)) {
          contentIdsArr.push(skillObj.skillId);
        }
      });
      content.grammar.forEach((skillObj) => {
        if (!contentIdsArr.includes(skillObj.skillId)) {
          contentIdsArr.push(skillObj.skillId);
        }
      });
    } else if (!newAllChecked) {
      content.language.forEach((skillObj) => {
        contentIdsArr.forEach((contentId, index) => {
          if (contentId === skillObj.skillId) {
            contentIdsArr.splice(index, 1);
          }
        });
      });
      content.functional.forEach((skillObj) => {
        contentIdsArr.forEach((contentId, index) => {
          if (contentId === skillObj.skillId) {
            contentIdsArr.splice(index, 1);
          }
        });
      });
      content.grammar.forEach((skillObj) => {
        contentIdsArr.forEach((contentId, index) => {
          if (contentId === skillObj.skillId) {
            contentIdsArr.splice(index, 1);
          }
        });
      });
    }
    setContentIds(contentIdsArr);
  };

  return (
    <AccordionDetails>
      <Grid container md={4} justifyContent="center" alignItems="center" direction="row">
        <FormControlLabel
          checked={allChecked}
          control={<Checkbox color="primary" />}
          label="Select all"
          onChange={handleAllChecked}
          className={classes.total}
        />
      </Grid>
      <Grid item md={4} direction="column" style={{ display: 'flex', flexDirection: 'column' }}>
        {content.functional.map((item) => (
          <ContentCheckbox
            item={item}
            allChecked={allChecked}
            contentIds={contentIds}
            setContentIds={setContentIds}
          />
        ))}
      </Grid>
      <Grid item md={4} direction="column" style={{ display: 'flex', flexDirection: 'column' }}>
        {content.language.map((item) => (
          <ContentCheckbox
            item={item}
            allChecked={allChecked}
            contentIds={contentIds}
            setContentIds={setContentIds}
          />
        ))}
      </Grid>
    </AccordionDetails>
  );
};

ContentDetails.propTypes = {
  content: PropTypes.array.isRequired,
  group: PropTypes.object.isRequired,
  groupId: PropTypes.string.isRequired,
  skillTitleId: PropTypes.string.isRequired,
  contentIds: PropTypes.array.isRequired,
  setContentIds: PropTypes.func.isRequired,
};

export default ContentDetails;
